import { z } from 'zod';

// 'main' is the active system prompt; 'extra' is the deprecated legacy name —
// historic version rows still appear in responses, so the response schema must
// accept both. Writes to 'extra' are rejected at the API layer.
const systemPromptNameSchema = z.enum(['main', 'extra']);

// ─── Request schemas ──────────────────────────────────────────────────────────

export const UpdateSystemPromptRequestSchema = z.object({
  content: z.string().min(1),
});
export type UpdateSystemPromptRequest = z.infer<typeof UpdateSystemPromptRequestSchema>;

// ─── Response schemas ─────────────────────────────────────────────────────────

export const SystemPromptResponseSchema = z.object({
  id: z.string().uuid(),
  version: z.number().int().positive(),
  name: systemPromptNameSchema,
  content: z.string(),
  isCurrent: z.boolean(),
  createdAt: z.string(),
  createdBy: z.string().uuid().nullable().optional(),
});
export type SystemPromptResponse = z.infer<typeof SystemPromptResponseSchema>;

export const ListSystemPromptsResponseSchema = z.object({
  ok: z.literal(true),
  items: z.array(SystemPromptResponseSchema),
});
export type ListSystemPromptsResponse = z.infer<typeof ListSystemPromptsResponseSchema>;
